export default "__VITE_ASSET__jq_1te8F__"